import { render } from "./ResultsGridnew.vue?vue&type=template&id=770a43d7&scoped=true"
import script from "./ResultsGridnew.vue?vue&type=script&lang=js"
export * from "./ResultsGridnew.vue?vue&type=script&lang=js"

import "./ResultsGridnew.vue?vue&type=style&index=0&id=770a43d7&lang=scss"
import "./ResultsGridnew.vue?vue&type=style&index=1&id=770a43d7&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770a43d7"]])

export default __exports__